(function () {
  'use strict';

  function updateDots(slider, dots) {
    if (!slider || !dots || dots.length === 0) return;

    var slideWidth = slider.clientWidth || 1;
    var currentIndex = Math.round(slider.scrollLeft / slideWidth);

    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === currentIndex);
    });
  }

  function initSlider(card) {
    var slider = card.querySelector('[data-card-slider]');
    var dots = card.querySelectorAll('.wb-cards__dot');
    var btnPrev = card.querySelector('.wb-cards__arrow--prev');
    var btnNext = card.querySelector('.wb-cards__arrow--next');

    if (!slider || slider.dataset.wbSliderReady === 'true') return;

    slider.dataset.wbSliderReady = 'true';

    var rafId = null;

    function onScroll() {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(function () {
        updateDots(slider, dots);
        rafId = null;
      });
    }

    slider.addEventListener('scroll', onScroll, { passive: true });
    updateDots(slider, dots);

    if (btnPrev) {
      btnPrev.addEventListener('click', function (event) {
        event.preventDefault();

        slider.scrollTo({
          left: Math.max(slider.scrollLeft - slider.clientWidth, 0),
          behavior: 'smooth'
        });
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function (event) {
        event.preventDefault();

        slider.scrollTo({
          left: Math.min(slider.scrollLeft + slider.clientWidth, slider.scrollWidth),
          behavior: 'smooth'
        });
      });
    }
  }

  function showError(form, message) {
    if (!form) return;

    var error = form.querySelector('[data-card-error]');
    if (!error) return;

    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }

    error.hidden = false;
    error.textContent = message;
  }

  function openThemeCartDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return true;
    }

    var trigger = document.getElementById('CustomCartTrigger');
    if (trigger) {
      trigger.click();
      return true;
    }

    return false;
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('wb:cart:updated'));
  }

  function setButtonState(button, state) {
    if (!button) return;

    var text = button.querySelector('[data-card-btn-text]');
    var addLabel = button.getAttribute('data-add-label') || (text ? text.textContent : 'Ajouter');
    var loadingLabel = button.getAttribute('data-loading-label') || 'Ajout...';
    var addedLabel = button.getAttribute('data-added-label') || 'Ajouté';

    button.classList.remove('is-loading', 'is-success');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;

      if (text) text.textContent = loadingLabel;
      return;
    }

    if (state === 'success') {
      button.classList.add('is-success');
      button.disabled = false;

      if (text) text.textContent = addedLabel;

      setTimeout(function () {
        button.classList.remove('is-success');
        if (text) text.textContent = addLabel;
      }, 1200);

      return;
    }

    button.disabled = false;
    if (text) text.textContent = addLabel;
  }

  async function addToCart(form) {
    var variantInput = form.querySelector('[data-card-variant-input], [name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      throw new Error('Variante introuvable.');
    }

    var variantId = Number(variantInput.value);
    var quantity = quantityInput && quantityInput.value ? Number(quantityInput.value) : 1;

    if (!variantId) {
      throw new Error('Variante invalide.');
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity || 1
          }
        ]
      })
    });

    var data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      var message = data && data.description ? data.description : 'Impossible d’ajouter ce produit au panier.';
      throw new Error(message);
    }

    return data;
  }

  function initVariants(card) {
    var variantsWrapper = card.querySelector('[data-card-variants]');

    if (!variantsWrapper || variantsWrapper.dataset.wbVariantsReady === 'true') return;

    variantsWrapper.dataset.wbVariantsReady = 'true';

    variantsWrapper.addEventListener('click', function (event) {
      var button = event.target.closest('.wb-cards__variant-opt');

      if (!button || button.disabled || button.classList.contains('is-disabled')) return;

      variantsWrapper.querySelectorAll('.wb-cards__variant-opt').forEach(function (item) {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      var variantInput = card.querySelector('[data-card-variant-input]');
      var price = card.querySelector('[data-card-price]');
      var submitBtn = card.querySelector('.wb-cards__btn-submit');
      var btnText = card.querySelector('[data-card-btn-text]');
      var available = button.getAttribute('data-variant-available') === 'true';

      if (variantInput && button.dataset.variantId) {
        variantInput.value = button.dataset.variantId;
      }

      if (price && button.dataset.variantPrice) {
        price.textContent = button.dataset.variantPrice;
      }

      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.classList.remove('is-loading', 'is-success');

        if (btnText) {
          btnText.textContent = available
            ? (submitBtn.getAttribute('data-add-label') || 'Ajouter')
            : 'Épuisé';
        }
      }

      var form = card.querySelector('[data-card-form]');
      showError(form, '');
    });
  }

  function initForm(card) {
    var form = card.querySelector('[data-card-form]');
    var submitBtn = card.querySelector('.wb-cards__btn-submit');

    if (!form || !submitBtn || form.dataset.wbFormReady === 'true') return;

    form.dataset.wbFormReady = 'true';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (submitBtn.classList.contains('is-loading')) return;

      showError(form, '');
      setButtonState(submitBtn, 'loading');

      try {
        await addToCart(form);
        dispatchCartEvents();
        openThemeCartDrawer();
        setButtonState(submitBtn, 'success');
      } catch (error) {
        showError(form, error && error.message ? error.message : 'Impossible d’ajouter ce produit au panier.');
        setButtonState(submitBtn, 'idle');
      }
    });
  }

  function initSection(section) {
    if (!section) return;

    section.querySelectorAll('.wb-cards__item').forEach(function (card) {
      initSlider(card);
      initVariants(card);
      initForm(card);
    });
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('.wb-cards').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();